import { StyleSheet } from "aphrodite";
import { colorMaps } from "../../lib/utils";
let diaryDetails = colorMaps.diaryDetails;

const TimelineStyle = StyleSheet.create({
  timeline: {
    //position: "relative",
    padding: "15px 0px 0px 0px",
    margin: "0px 0px",
    ":after": {
      content: "''",
      position: "absolute",
      width: "2px",
      backgroundColor: "#CCC",
      top: "0",
      bottom: "0",
      left: "1%",
      boxSizing: "border-box",
      zIndex: "-1",
    },
  },
  container: {
    width: "15px",
    height: "15px",
    backgroundColor: "#C90000",
    border: "4px solid #C90000",
    borderRadius: "50%",
    zIndex: "1",
    marginRight: "1em"
  },
  containerbleeds: {
      backgroundColor: diaryDetails.bleeds,
      border: `4px solid ${diaryDetails.bleeds}`,
  },
  containerhelp: {
      backgroundColor: diaryDetails.help,
      border: `4px solid ${diaryDetails.help}`,
  },
  containersymptoms: {
      backgroundColor: diaryDetails.symptoms,
      border: `4px solid ${diaryDetails.symptoms}`,
  },
  containervisits: {
      backgroundColor: diaryDetails.visits,
      border: `4px solid ${diaryDetails.visits}`,
  },
  containerreminders: {
      backgroundColor: diaryDetails.reminders,
      border: `4px solid ${diaryDetails.reminders}`,
  },
  containerweightlogs: {
    backgroundColor: diaryDetails.weightlogs,
    border: `4px solid ${diaryDetails.weightlogs}`,
  },
  containerinhibitorStatus: {
      backgroundColor: diaryDetails.inhibitorStatus,
      border: `4px solid ${diaryDetails.inhibitorStatus}`,
  },
  containertreatmentLogs: {
      backgroundColor: diaryDetails.treatmentLogs,
      border: `4px solid ${diaryDetails.treatmentLogs}`,
  },
  containernocircle: {
    ":after": {
      backgroundColor: "transparent",
      border: "0px",
    },
  },
  content: {
    /*padding: "20px 30px",*/
    padding: "10px 5px",
    backgroundColor: "#FFFFFF",
    boxShadow: "5px 5px 5px 5px #E2E2E2",
    position: "relative",
    borderRadius: "6px",
    boxSizing: "border-box",
    width: "100%",
  },
  contentNoShadow: {
    padding: "10px 5px",
    margin: "15px 0px",
    backgroundColor: "#FFFFFF",
    position: "relative",
    borderRadius: "6px",
    boxSizing: "border-box",
    width: "100%",
    //border: "1px solid white"
  },
  timelineDetails: {
    //padding: "0px",
    //height: "100%",
    background:
      "linear-gradient(157deg, #3D58B4, #00A1DB), url('/images/diary/medical_visit_event_icon@2x.png') no-repeat center",
  },
  bgDiv: {
    ":before": {
      backgroundImage: "url('/images/diary/medical_visit_event_icon@2x.png')",
      backgroundSize: "cover",
      content: "",
      display: "block",
      position: "absolute",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      zIndex: "900",
      opacity: "0.4",
    },
  },
  eventAreaStyle: {
    resize: "none",
    fontSize: "14px",
  },
});

export default TimelineStyle;
